const BorderlessTextAreaInput = (props) => {
    return (
        <textarea 
            className='focus:border-transparent focus:outline-none gap-2.5 self-stretch font-montserrat h-10 w-full pt-2'
            id={props.id} 
            type={props.type}
            value={props.value}
            placeholder={props.placeholder}
            onChange={props.onChange}
        />
    )
}

export default BorderlessTextAreaInput